import { Component } from '@angular/core';
import { App, MenuController, NavController } from 'ionic-angular';
import { LoginControl } from '../../providers/helpers/login';
import { MessageHelper } from '../../providers/helpers/messages';
import { ServiceProvider } from '../../providers/service/service';
import { LoginPage } from '../login/login';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

  user: any = null;
  totalMatriculas : number = 0;
  totalCobrancas : any = null;

  constructor(public navCtrl: NavController, private loginCtrl: LoginControl,
    private menuCtrl: MenuController, private msgHelper: MessageHelper,
    private service: ServiceProvider, private app : App) {
      this.user = this.loginCtrl.getUser();
      this.checkUser();
  }

  ionViewWillEnter() {
    this.menuCtrl.enable(true, "menu-principal");
    this.user = this.loginCtrl.getUser();
    this.getTotalMatriculas(); 
    this.getTotaisCobrancas();
  }

  private checkUser() {
    if(this.user == null){
      return false;
    }
    this.msgHelper.createLoading('crescent', 'Carregando...');
    this.msgHelper.showLoading();
    this.service.postData({ token: this.user.token }, "/usuarios/details", false).then(result => {
      this.msgHelper.closeLoading();
      let resultData: any = result;
      if (resultData.result == 0) {
        this.msgHelper.showAlert("Opss!", resultData.message);
        this.loginCtrl.clearAll();
        this.menuCtrl.close('menu-principal');
        this.menuCtrl.enable(false, "menu-principal");
        this.app.getActiveNavs()[0].setRoot(LoginPage);
        this.app.getActiveNavs()[0].popToRoot();
      }
      this.loginCtrl.setUser(resultData.data);
    }, error => {
      this.msgHelper.closeLoading();
      this.msgHelper.showAlert("Opps", error.message);
    });
  }

  /**
   * Retorna os totais de matrículas
   */
  private getTotalMatriculas()
  {
    this.service.postData({},"/matriculas/total").then(result => {
      let resultData: any = result;
      this.totalMatriculas = resultData.total;
    });
  }

  /**
   * Retorna os totais de cobrancas
   */
  private getTotaisCobrancas(){
    this.service.postData({},"/cobrancas/totais").then(result => {
      let resultData: any = result;
      this.totalCobrancas = resultData;
      console.log(this.totalCobrancas);
    });
  }

  transformValor(valor : number, withCurrency : boolean = false)
  {
    var numero = valor.toFixed(2).split('.');
    numero[0] =  numero[0].split(/(?=(?:...)*$)/).join('.');
    if (withCurrency){
      return "R$" + numero.join(',');
    }
    return numero.join(',');
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts